import { render, staticRenderFns } from "./UnderConstruction.vue?vue&type=template&id=24617ab4&scoped=true&"
import script from "./UnderConstruction.vue?vue&type=script&lang=js&"
export * from "./UnderConstruction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24617ab4",
  null
  
)

export default component.exports